<section class="content">
  <div class="card" style="padding: 24px;">

    <div class="container">
      <div class="row">
        <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
          {{title}}
        </div>
      </div>
      <div class="row">
        <!-- <div class="col-2">
          <mat-label>Select Inputs</mat-label>
          <mat-select [(ngModel)]="selected_inp_type" class="main-border-class">
            <mat-option [value]="inp_type" *ngFor="let inp_type of inp_types">{{inp_type}}</mat-option>
          </mat-select>
        </div> -->
        <div class="col-3">
          <mat-label>Select Months</mat-label>
          <mat-select [(ngModel)]="selected_month" class="main-border-class">
            <mat-option *ngFor="let month of month_list_for_last_12_months" [value]="month">{{month['month_in_string']}} - {{month['year']}}</mat-option>
          </mat-select>
        </div>

        <!-- <div class="col-3" *ngIf="selected_inp_type == 'Date Range'">
            <mat-label style="color: firebrick;">From Date</mat-label>
            <input type="date" [(ngModel)]="selected_from_date" class="main-border-class">
        </div> -->

        <!-- <div class="col-3" *ngIf="selected_inp_type == 'Date Range'" style="padding-left: 35px;">
          <mat-label style="color: firebrick;">To Date</mat-label>
          <input type="date" [(ngModel)]="selected_to_date" [min]="selected_from_date" class="main-border-class">
        </div> -->

        <!-- <div class="col-2" *ngIf="selected_inp_type == 'Date Range'">
          <mat-label>Select Months</mat-label>
          <mat-select [(ngModel)]="selected_month" class="main-border-class">
            <mat-option *ngFor="let month of month_list_for_last_12_months" [value]="month">{{month['month_in_string']}} - {{month['year']}}</mat-option>
          </mat-select>
        </div> -->


        <div class="col-2">
          <button (click)="getClicked()"
            style="font-size: 27px;margin-top: 14%;border-radius: 5px;background: blanchedalmond;"
            [disabled]="selected_month == null">Get</button>
        </div>

        <!-- <div class="col-2" style="padding-left: 35px;" *ngIf="selected_inp_type == 'Date Range'">
          <button (click)="getClicked()"
            style="font-size: 27px; margin-top: 14%;border-radius: 5px;background: blanchedalmond;"
            [disabled]="selected_inp_type == null || selected_from_date == null || selected_to_date == null ">Get</button>
        </div> -->
    </div>
  <br><br><br><br>
      <div *ngIf="!is_document_available">
        <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
        </mat-progress-spinner>
      </div>
      <div class="row" *ngIf="document_file !== null">
        <div class="col-6"></div>
        <div class="col-6">
          <div class="row">
            <div class="col-4">
            </div>
            <div class="col-4">
              <button mat-button class="button-class" (click)="downloadClicked()"><i class="material-icons">
                  picture_as_pdf
                </i> Download PDF </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

  </section>
